export default __webpack_public_path__ + "navigation-examples-building-extrusion-v1-1200-b3d60b00bddcd3f315eec0fc4ffc05ed.png";